// src/app/features/offer/components/offer-submit-view.tsx

import React from "react";
import { Button, Box } from "@mui/material";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import { Trash2, Loader2 } from "lucide-react";

interface TenderdeleteSubmitViewProps {
  isLoading: boolean;
  onClick: () => void;
}

const DeleteOfferSubmitView: React.FC<TenderdeleteSubmitViewProps> = ({
  isLoading,
  onClick,
}) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);

  return (
    <Box>
      <Button
        variant="contained"
        className="!bg-red-600"
        disabled={isLoading}
        onClick={onClick}
        startIcon={
          isLoading ? (
            <Loader2 size={16} className="animate-spin" />
          ) : (
            <Trash2 size={16} />
          )
        }
        sx={{
          borderRadius: 2,
          px: 3,
          py: 1.5,
          textTransform: "none",
          fontWeight: 500,
          "&.Mui-disabled": {
            backgroundColor: "#f3f4f6",
            color: "#9ca3af",
          },
        }}
      >
        {isLoading
          ? t("actions.processingDeleteOffer")
          : t("actions.deleteRequest")}
      </Button>
    </Box>
  );
};

export default DeleteOfferSubmitView;
